import { useQuery } from '@tanstack/react-query'

import { api } from './api'

export const CLAVE_FICHA_NEGOCIO = (accountId: string) => ['negocio-nombre', accountId] as const

export interface FichaNegocio {
    businessName?: string
    estadoAlta?: string
    chatwootUrl?: string | null
}

export function useFichaNegocio(accountId: string | undefined) {
    const { data } = useQuery<FichaNegocio>({
        queryKey: CLAVE_FICHA_NEGOCIO(accountId ?? ''),
        queryFn: () => api.get<FichaNegocio>(`/business/${accountId}/summary`),
        enabled: Boolean(accountId),
        staleTime: 10 * 60_000,
        retry: false,
    })
    return {
        nombre: data?.businessName,
        estadoAlta: data?.estadoAlta,
        chatwootUrl: data?.chatwootUrl ?? null,
        esDemo: data ? data.estadoAlta === 'demo' : undefined,
    }
}
